var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var moment = require('moment');
var dashboardUtils = require('../../utils');
var BellChart = require('./bellChart.jsx');

var Bell = createReactClass({
    mixins: [PureRenderMixin],

    render: function(){
        var itemScore = this.props.itemScores[this.props.itemScores.length - 1];
        var previousItemScore = this.props.itemScores[this.props.itemScores.length - 2] || {};
        var itemScoreSeverityLevel = dashboardUtils.getSeverityLevel(itemScore.percentile);
        var previousItemScoreSeverityLevel = dashboardUtils.getSeverityLevel(previousItemScore.percentile);
        var isIncreased = itemScore.percentile > previousItemScore.percentile;
        var shouldShowSevereTrend = Object.keys(previousItemScore).length > 0 && itemScoreSeverityLevel !== previousItemScoreSeverityLevel;
        var shouldShowSevereAlarm = itemScoreSeverityLevel === 'extreme';
        var shouldShowSevereInfo = shouldShowSevereTrend || shouldShowSevereAlarm;

        return (
            <div className={'dashboard-bell clearfix' + (shouldShowSevereInfo ? ' is-showing-severe-info' : '')}>
                <h2 className="show-for-medium">More about your {this.props.item.displayName}</h2>
                <div className="flex-container">
                    <div className="bell-chart-severe-des">
                        <BellChart percentile={itemScore.percentile}></BellChart>
                        <p className="severe-des">
                            Your {this.props.item.displayName} is more severe than {itemScore.percentile - 1}% of the people we surveyed
                            <span className="show-for-medium">({itemScore.percentile}th percentile)</span>
                        </p>
                    </div>
                    {shouldShowSevereInfo &&
                        <div className="severe-info-wrap">
                            {shouldShowSevereTrend &&
                                <p className="severe-trend">
                                    <span className={isIncreased ? 'ion-arrow-graph-up-right' : 'ion-arrow-graph-down-right'}></span>
                                    {isIncreased ? 'Increased' : 'Decreased'} from {previousItemScoreSeverityLevel} to {itemScoreSeverityLevel}
                                    <span className="show-for-medium">(since pervious survey on {moment(previousItemScore.timestamp).format("M/D")})</span>
                                </p>
                            }
                            {shouldShowSevereAlarm &&
                                <p className="severe-alarm"><span className="ion-alert-circled"></span>Consider discussing with your doctor</p>
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }
});

module.exports = Bell;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/bell.jsx